
import { useState } from 'react';

export default function Download() {
  const [selectedPlatform, setSelectedPlatform] = useState('macos');

  const platforms = [
    { id: 'macos', name: 'macOS', icon: 'ri-apple-line' },
    { id: 'ios', name: 'iOS', icon: 'ri-app-store-line' }
  ];

  const features = [
    'One-click installation',
    'Automatic updates',
    'User-friendly interface',
    '24/7 customer support'
  ];

  const requirements = {
    macos: 'macOS 10.15 or later',
    ios: 'iOS 13.0 or later'
  };

  return (
    <section id="download" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Download & Setup
            </h2>
            
            <p className="text-lg text-gray-600 mb-8">
              Get AGIT VPN on all your devices and enjoy secure browsing everywhere you go.
            </p>

            <div className="space-y-4 mb-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-green-600 text-sm"></i>
                  </div>
                  <span className="text-gray-700 font-medium">{feature}</span>
                </div>
              ))}
            </div>

            <div className="bg-gray-50 rounded-xl p-4">
              <p className="text-sm text-gray-600">
                <strong>System Requirements:</strong> {requirements[selectedPlatform as keyof typeof requirements]}
              </p>
              <p className="text-sm text-gray-600 mt-2">
                <strong>File Size:</strong> ~50 MB | <strong>Version:</strong> 2.5.0
              </p>
            </div>
          </div>

          <div>
            <div className="bg-gradient-to-br from-blue-600 to-purple-600 rounded-3xl p-8 shadow-2xl">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
                <h3 className="text-white text-2xl font-bold mb-6 text-center">
                  Choose Your Platform
                </h3>

                <div className="flex flex-wrap gap-2 mb-8 justify-center">
                  {platforms.map((platform) => (
                    <button
                      key={platform.id}
                      onClick={() => setSelectedPlatform(platform.id)}
                      className={`px-4 py-2 rounded-lg font-medium transition-all whitespace-nowrap cursor-pointer ${
                        selectedPlatform === platform.id
                          ? 'bg-white text-blue-600 shadow-lg'
                          : 'bg-white/20 text-white hover:bg-white/30'
                      }`}
                    >
                      <i className={`${platform.icon} mr-2`}></i>
                      {platform.name}
                    </button>
                  ))}
                </div>

                <button className="w-full bg-white text-blue-600 py-4 rounded-xl font-bold text-lg hover:shadow-xl transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer">
                  <i className="ri-download-line text-2xl"></i>
                  Download for {platforms.find(p => p.id === selectedPlatform)?.name}
                </button>

                <div className="mt-6 text-center">
                  <a href="#" className="text-white/80 text-sm hover:text-white transition-colors">
                    Alternative download methods →
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
